module.exports = __webpack_public_path__ + "img/select-square.9e795846.svg";